var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment"},[_c('payment'),_c('my_button',{attrs:{"value":"已完成支付"},nativeOn:{"click":function($event){return _vm.back($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }